export enum EnvironmentType {
	NextGen = "NextGen",
	Joomla = "joomla",
}

export enum CategoryAssessment {
	fail = 0,
	borderline = 1,
	pass = 2,
	hazardous = 3,
}

export const getCoreState = (statusId?: number): CutpointState | undefined => {
	switch (statusId) {
		case CategoryAssessment.borderline:
			return "Borderline";
		case CategoryAssessment.fail:
			return "Fail";
		case CategoryAssessment.hazardous:
			return "Hazardous";
		case CategoryAssessment.pass:
			return "Pass";
	}
	return undefined;
};

export const getVitalsMState = (
	recommendation?: CareScoringDecisionType
): CutpointState | undefined => {
	switch (recommendation) {
		case "RangeOfInquiry":
			return "Borderline";
		case "Fail":
			return "Fail";
		case "Pass":
			return "Pass";
		case "Aborted":
			return "Aborted";
	}
	return undefined;
};

// Maps a NeurapulseRecommendation value to a CutpointState the Overall dial's
// 4th-pillar Indicator understands. Used when the report is in NP-mode (no
// Vitals, NP completed) — the 4th pillar surfaces NP outcome instead of Vitals.
//
// Note: in this codebase NeurapulseRecommendationType has two declarations —
// a string union in ServiceStackTypes.d.ts (used by ReportNecessaryInfoDTO),
// and a numeric enum in the NSwag-generated ImpiricaPlatformApi.ts. The string
// union is the one we hit at the report layer, so we switch on the names.
export const getNeurapulseDialState = (
	recommendation?: NeurapulseRecommendationType
): CutpointState | undefined => {
	switch (recommendation) {
		case "Completed":
			return "Pass";
		case "Incomplete":
			return "Aborted";
		case "HighRisk":
			return "Fail";
	}
	return undefined;
};

export enum ModuleType {
	"Trip Inspection" = 1,
	"CORE" = 2,
	"VITALS" = 3,
	"DORE" = 4,
	"DCAT" = 5,
}

export enum NeurapulseTestCompletionStatusType {
  UnknownStatus = 0,
  UnknownError = 1,
  Completed = 2,
  CouldNotCompleteConnectionIssues = 3,
  CouldNotCompleteNpServerIssues = 4,
  CouldNotCompleteTimedOut = 5,
  CouldNotCompleteUnsupportedDevice = 6,
  Confirming = 7,
  HighRisk = 8,
  Active = 9,
  NotStarted = 10,
}
